var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var CalendarEntryController = /** @class */ (function () {
    function CalendarEntryController() {
    }
    /*****************************************************************************************************
        * Is using route "api/calendar/list" and http method "POST" to call the back-end.
    
        * @param {TokenContainer} token
        * @returns {ExtendedDataCollection<CalendarEntryDownloadDto, string>}
    ******************************************************************************************************/
    CalendarEntryController.GetList = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/calendar/list", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.token
        });
    };
    /*****************************************************************************************************
        * Is using route "api/calendar/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {CalendarEntryDownloadDto}
    ******************************************************************************************************/
    CalendarEntryController.Get = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/calendar/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/calendar" and http method "POST" to call the back-end.
    
        * @param {CalendarEntryUploadDto} data
        * @param {File} media
        * @returns {CalendarEntryDownloadDto}
    ******************************************************************************************************/
    CalendarEntryController.Post = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("data", JSON.stringify(data.data));
        if (data.media)
            fd.append("media", data.media);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/calendar", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/calendar/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {CalendarEntryUploadDto} data
        * @param {File} media
        * @returns {CalendarEntryDownloadDto}
    ******************************************************************************************************/
    CalendarEntryController.Patch = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("data", JSON.stringify(data.data));
        if (data.media)
            fd.append("media", data.media);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/calendar/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/calendar/{id}" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    CalendarEntryController.Delete = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/calendar/{id}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    return CalendarEntryController;
}());
export { CalendarEntryController };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=CalendarEntryController.js.map